import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
import CommentTooltip from './CommentTooltip';
import useCommentOnDownloadSuggest from './useCommentOnDownloadSuggest';
var logger = ddt.createLogger('downloadbutton');
/** Wraps the download button in handlers that, when a download starts, open
 *  a tooltip that suggests the user add a comment to the deviation too. */
var DownloadButtonWithCommentPrompt = function (_a) {
    var ButtonComponent = _a.buttonComponent, deviation = _a.deviation, className = _a.className;
    var _b = useCommentOnDownloadSuggest(), commentTooltipVisible = _b.commentTooltipVisible, showTooltip = _b.showCommentSuggestionTooltip, hideTooltip = _b.hideCommentSuggestionTooltip, pauseTooltip = _b.pauseCommentSuggestionTooltip, resumeTooltip = _b.resumeCommentSuggestionTooltip;
    // todo: consider moving useCommentOnDownloadSuggest into this component
    var dispatch = useDispatch();
    var handleTooltipDismiss = useCallback(function () {
        logger.log('hiding tooltip and expanding comment box');
        hideTooltip();
        dispatch(expandAndFocusCommentPanel(deviation, 'primary'));
    }, [hideTooltip, dispatch, deviation]);
    var downloadButton = (React.createElement(ButtonComponent, { deviation: deviation, onDownload: showTooltip, onMouseEnter: pauseTooltip, onMouseLeave: resumeTooltip }));
    commentTooltipVisible && logger.log('comment tooltip should be visible');
    return commentTooltipVisible ? (React.createElement(CommentTooltip, { className: className, onDismiss: handleTooltipDismiss }, downloadButton)) : (React.createElement("span", { className: className }, downloadButton));
};
DownloadButtonWithCommentPrompt.displayName = 'DownloadButtonWithCommentPrompt';
export default DownloadButtonWithCommentPrompt;
//# sourceMappingURL=DownloadButtonWithCommentPrompt.js.map